module.exports = __webpack_public_path__ + "static/dark-logo-3-be05c3c04b6ddc999c140e7b759a9c9b.png";